export interface SalesOrderHeaderLine {
  id: string;
  salesOrderHeaderId: string;
  salesOrderAndLineNo: string;
  sequence: number;
  status: string;
  allocationType: string;
  contractNo: number;
  productType: string;
  productId: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  supplierDescription: string;
  customerDescription: string;
  quantity: number;
  quantityDespatched: number;
  balance: number;
  unitOfMeasure: string;
  priceListQuantity: number;
  priceListUom: string;
  noOfItems: number;
  price: number;
  discount: number;
  lineValue: number;
  exStock: string;
  urgent: string;
  deliveryDate: Date;
  customerLineRef: string;
  reserved: string;
  reservationExpiryDate: Date;
  billOfMaterialItems: boolean;
  confirmed: string;
  currency: string;

  // todo - Added these fields to either show or hide the delete button on Sales-Order-lines grid. How can this be done in grid-component?
  canDelete: boolean;
  allocated: boolean;
  despatched: boolean;
  invoiced: boolean;
  nearestEighth: boolean;
  colour: string;
}
